export default {
  sessionNotificationTime: 5
};
